module.exports = __webpack_public_path__ + "static/media/yuangongdengjibiao2.9b0ab28d.png";